<template lang="pug">
	div(id="root")
		div(v-if="!$userInfo.appIsBusy", :class="cssClasses")
			router-view(:is-x-small="screen.isXSmall", :is-large="screen.isLarge")
			router-view(name="layout", :is-x-small="screen.isXSmall", :is-large="screen.isLarge")
				.content
					router-view(name="content")
				template(v-slot:#footer)
					the-footer
		.flex-row.full-width.full-height.center.align-center.loading-screen(v-else)
			Loader.remember-loader(:text="''")
				img(slot="left", src="./assets/logo_transparent.png" height="60px")
		Notifier
</template>

<script>
import TheFooter from './components/the-footer.vue';
import { sizes, subscribe, unsubscribe } from './utils/media-query';
import config from 'app-core/config';
import Notifier from 'app-core/Notifier.vue';
import Loader from 'app-core/Loader.vue';

function getScreenSizeInfo() {
	const screenSizes = sizes();

	return {
		isXSmall: screenSizes['screen-x-small'],
		isLarge: screenSizes['screen-large'],
		cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
	};
}

export default {
	name: 'app',
	components: {
		TheFooter, Notifier, Loader
	},
	data() {
		return {
			title: this.$appInfo.title,
			screen: getScreenSizeInfo()
		};
	},
	computed: {
		cssClasses() {
			return ['app'].concat(this.screen.cssClasses);
		}
	},
	mounted() {
		subscribe(this.screenSizeChanged);
		config.checkVersion(true);
		this.$auth.loadVersion();
	},
	beforeDestroy() {
		unsubscribe(this.screenSizeChanged);
	},
	methods: {
		screenSizeChanged() {
			this.screen = getScreenSizeInfo();
		}
	}
};
</script>

<style lang="scss">
	html,
	body {
		margin: 0px;
		min-height: 100%;
		height: 100%;
	}

	#root {
		height: 100%;

		.loading-screen {
			background-color: #f2f2f2;
		}
	}

	* {
		box-sizing: border-box;
	}

	@import "./themes/generated/variables.base.scss";

	.app {
		background-color: darken($base-bg, 5);
		display: flex;
		height: 100%;
		width: 100%;
	}

	@import "./flex-styles.scss";
	@import "./dx-styles.scss";
	@import "assets/filter-fonts/filter-fonts.scss";
</style>
